module.exports = __webpack_public_path__ + "static/img/home04.41c65606.jpg";